import { Modal } from "antd";

export const AntModal = Modal;
